import Keepa from 'assets/html-pwa/Keepa/logo192.png';
import Entekhab from 'assets/html-pwa/Entekhab/192-type2.png';
import hamtaland from 'assets/html-pwa/Hamtaland/hamtaland - 192-min.png';
import rayansaipa from 'assets/html-pwa/Rayansaipa/180-180 (1).png';
import tisa from 'assets/html-pwa/Tisa/176.png';
import saana from 'assets/html-pwa/Saana/176.png';
import arbaeen from 'assets/html-pwa/Arbaeen/176.png';

import iosPWASplash from 'ios-pwa-splash';

const usePwaSplash = () => {
	const projectName = process.env.REACT_APP_PROJECT_NAME;

	const returnColorSplash = {
		keepa: {
			color: '#35306f',
			icon: Keepa,
		},
		entekhab: {
			color: '#00A361',
			icon: Entekhab,
		},
		hamtaland: {
			color: '#ffffff',
			icon: hamtaland,
		},
		rayansaipa: {
			color: '#ffff',
			icon: rayansaipa,
		},
		tisa: {
			color: '#ffff',
			icon: tisa,
		},
		saana: {
			color: '#ffff',
			icon: saana,
		},
		arbaeen: {
			color: '#ffff',
			icon: arbaeen,
		},
		demo: {
			color: '',
			icon: '',
		},
	};

	iosPWASplash(returnColorSplash[projectName]?.icon, returnColorSplash[projectName]?.color);

	return null;
};

export default usePwaSplash;
